import React from 'react'

export const Success = () => {
    return (
        <section className="height-100 text-center">
            <div className="container pos-vertical-center">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="h1--large">Payment Successful!</h1>
                        <p className="lead">Our team will contact you in the next 48 hours.</p> <a href="/">Go back to home page</a> </div>
                </div>
            </div>
        </section>
    )
}
